<!-- TEMPLATE -->
<template>
  <div class="deanDashboardTile">
    <a @click="buttonClick" v-if="$store.getters.getUser.privileges.includes('create-quote')">
      <dean-icon
              className="plusIcon"
              :glyph="plusIcon"
              width="100"
              height="100"
              title="Status">
      </dean-icon>
      <div class="text">
        <strong>Nieuwe</strong> offerte
      </div>

    </a>
  </div>
</template>
<!-- SCRIPT -->
<script lang="ts">

  import Vue from 'vue';
  import { Component, Prop, Watch } from 'vue-property-decorator';

  const width = 1;
  const height = 1;

  // DEAN COMPONENTS
  import {
    // COMPONENTS
    plusIcon,
    deanIcon,
    dashboardIcon,
  } from '@deanone/dean-components';

  @Component({
    components: {
      plusIcon,
      deanIcon,
      dashboardIcon,
    },
  })

  export default class NewOfferWidget extends Vue {
    public plusIcon: object = plusIcon;
    public paId: string = '';

    public buttonClick() {
      this.$router.push({name: 'quotes.add.customers.list'});

      this.$store.dispatch('requestHeader');
    }
  }
</script>
git
<!-- STYLE -->
<style lang="scss" scoped>

  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';

  .deanDashboardTile {
    width: 100%;
    height: 100%;
    background-color: var(--color-dark, $color-dark);
    border-radius: 10px;
    box-shadow: 0 0 0.38rem rgba(0, 0, 0, 0.2);
  }

  .plusIcon {
    margin: 1rem;
    margin-top: 3rem;
    border-radius: 50%;
    background-color: var(--color-primary, $color-primary);
    fill: white;
    padding: 1rem;
    box-shadow: 0.23rem 0.23rem rgba(0, 0, 0, 0.2);
  }

  .text {
    color: rgb(255, 255, 255);
    font-size: 18.6667px;
    font-weight: 400;
    line-height: 21.4667px;
  }

</style>
